export default __webpack_public_path__ + "assets/images/logo_groesser_7b08c27a97b80827cf1ddf8c1f50b2bb.png";